<template>
    <div class="pd-12 top-border-bottom">
        <a class="exch-breadcrumb-heading-sec" @click="$router.go(-1)">
            <img  src="@/assets/images/back.webp" alt="back" >
            <h5 class="text-capitalize">Deposit & Withdraw Report</h5>
        </a>
    </div>
    <div class="exch-deposit-withdraw-wrapper">
        <div class="container">
            <div class="exch-deposit-withdraw-status-wrapper">
                <ul class="nav nav-pills" id="pills-tab" role="tablist">
                    <li role="presentation">
                        <button class="nav-link" :class="{active: filterType == 'client_deposit'}" @click="checkType('client_deposit')" id="pills-home-tab" data-bs-toggle="pill" type="button" role="tab" aria-controls="pills-home" :aria-selected="filterType == 'client_deposit'">
                            {{ $t('deposit', 'Deposit') }}
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="pills-profile-tab" :class="{active: filterType == 'client_withdrawal'}" @click="checkType('client_withdrawal')" type="button" data-bs-toggle="pill" role="tab" aria-controls="pills-profile"  :aria-selected="filterType == 'client_withdrawal'">
                            {{ $t('withdrawal', 'Withdrawal') }}
                        </button>
                    </li>
                </ul>
            </div>
            <select class="form-select form-control mb-2 get_wallet_history" v-model="selectedStatus">
                <option v-for="(item, index) in options" :key="index" :value="item.value">{{ item.label }}</option>
            </select>
            <template v-if="historyData.length">
                <div v-for="(group, index) in historyData" :key="index"  class="exch-deposit-withdraw-history-wrapper mt-2">
                    <div class="exch-deposit-withdraw-seprate-date mt-2 mb-2">
                        <span class="xs-bl-grey">{{ $dateTime.convertDate(group.date,"MMM DD, YYYY") }}</span>
                    </div>
                    <div v-for="(item, index) in group.items" :key="index" class="exch-deposit-withdraw-transaction-all-detail">
                        <a>
                            <div class="exch-deposit-withdraw-transaction-detail-wrapper" >
                                <div class="exch-deposit-withdraw-bank-sec" :class="getTransactionStatus(item?.status)?.class">
                                    <img :src="item?.status === 'approve_completed'
                                            ? require('@/assets/images/payment-approved.svg')
                                            : (item?.status === 'reject_completed' || item?.status === 'expired')
                                            ? require('@/assets/images/payment-rejected.svg')
                                            : require('@/assets/images/payment-processing.svg')"
                                        :alt="item?.status"
                                        />
                                </div>
                                <div class="exch-deposit-withdraw-transaction-detail-section">
                                    <div class="exch-deposit-withdraw-transaction-detail-top">
                                        <div class="transactionH-wrap">
                                            <span v-if="['approve_completed', 'reject_completed'].includes(item?.status)"
                                                class="xs-font text-decoration-underline cursor-pointer" @click="showReportDetailsModal(item)">
                                                {{ item?.type == 'client_deposit' || item.type == 'manual_deposit' ? $t('deposit', 'Deposit') : $t('withdraw', 'Withdraw') }}
                                                {{ $t('request', 'Request') }}
                                            </span>

                                            <span v-else class="xs-font">
                                                {{ item?.type == 'client_deposit' || item.type == 'manual_deposit' ? $t('deposit', 'Deposit') : $t('withdraw', 'Withdraw') }}
                                                {{ $t('request', 'Request') }}
                                            </span>
                                            <span class="exch-deposit-withdraw-status" :class="getTransactionStatus(item?.status)?.class">
                                                <span class="fa-regular fa-clock mr-3"></span>
                                                {{ getTransactionStatus(item?.status)?.label }}
                                            </span>
                                            <i v-if="['pending', 'approve_in_process', 'reject_in_process','hold'].includes(item.status)" @click="getWalletHistory(item)"
                                                :class="['fa', 'fa-refresh', {'fa-spin': selectedRequest?.c_a_tid == item?.c_a_tid?spinClass:false}]" aria-hidden="true"></i>
                                        </div>
                                        <span class="sm-xbd-font" :class="{'pending-color': item?.status === 'pending', 'rejected-color': item?.status === 'reject_completed', 'completed-color': item?.status === 'approve_completed'}">
                                            {{ item?.status === 'approve_completed' ? item?.approved_amount : item?.amount }}
                                        </span>
                                    </div>
                                    <div class="exch-deposit-withdraw-transaction-detail-bottom">
                                        <span class="xs-bl-grey">#{{ item?.client_user_name }}</span>
                                        <span class="xs-bl-grey xxs-font">{{ $dateTime.sportItemDate(item?.created_at, 'MMM DD, YYYY | hh:mm a') }}</span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </template>
            <template v-else>
                <NoDataFound />
            </template>
        </div>
    </div>

    <!-- Report Details Modal -->
    <DepositWithdrawReportDetail v-bind:reportDetail="selectedReport" @reset-function="getWalletHistory()"></DepositWithdrawReportDetail>
        
</template>

<script>
import { Modal } from "bootstrap";
import { defineAsyncComponent } from 'vue';
import dayjs from "dayjs";
import { getWalletHistory, getTransactionStatus } from '../services/walletHistory';
import NoDataFound from '@/shared/components/no-data/NoDataFound.vue';
import DepositWithdrawReportDetail from "../components/DepositWithdrawReportDetail.vue";
export default {
    name: "DepositWithdrawReport",
    components:{
        NoDataFound,
        DepositWithdrawReportDetail
    },
    data() {
        return {
            formDates:{
                fromDate: '',
                toDate: '',
            },
            options: [
                { label: this.$t('all', 'All'), value: 'all', selected:true },
                { label: this.$t('pending', 'Pending'), value: 'pending', selected:true },
                { label: this.$t('approved', 'Approved'), value: 'approve_completed', selected:true },
                { label: this.$t('rejected', 'Rejected'), value: 'reject_completed', selected:true },
                { label: this.$t('processing', 'Processing'), value: 'processing', selected:true },
                { label: this.$t('expired', 'Expired'), value: 'expired', selected:true },
            ],
            select_entries: 50,
            walletHistoryList: [],
            selectedReport: null,
            filterType: 'client_deposit',
            todayDate: new Date().toISOString().split('T')[0],
            selectedStatus: 'all',
            loading: false,
            spinClass: false,
            selectedRequest:null,
        }
    },
    created() {
        if(this.$auth.user.isDemo){
            this.$errorToast("Wallet access is restricted for demo user");
            setTimeout(() => {
                this.$router.push({name: 'Home'})
            }, 500);
        }
        const previousDate = this.$dateTime.getPreviousDate(30);
        this.formDates.fromDate = previousDate
        const currentDate = this.$dateTime.getcurrentDate() 
        this.formDates.toDate = currentDate;        
        this.getWalletHistory();
        this.changeType()
    },
    computed: {
        historyData() {
            let filteredStatus = null
            if(this.selectedStatus == 'all'){
                filteredStatus = this.walletHistoryList
            }else if(this.selectedStatus == 'processing'){
                filteredStatus = this.walletHistoryList.filter((history) => ['reject_in_process','approve_in_process','hold'].includes(history.status))
            }
            else if(!['all', 'processing'].includes(this.selectedStatus)){
                filteredStatus = this.walletHistoryList.filter((history) => history.status == this.selectedStatus)
            }
            const filteredData = filteredStatus?.filter(item => {
                const manualType = this.filterType.replace('client_', 'manual_');
                return item.type === this.filterType || item.type.includes(manualType);
            });
            const groupedData = filteredData.reduce((acc, item) => {
                const date = dayjs(item.created_at).format('YYYY-MM-DD');
                if (!acc[date]) {
                    acc[date] = [];
                }
                acc[date].push(item);
                return acc;
            }, {});

            return Object.keys(groupedData).map(date => ({
                date,
                items: groupedData[date],
            }));
        }
    },
    methods: {
        getTransactionStatus,
        changeType() {
             try {
                if (this.$route?.query?.['client-withdraw']) {
                    this.checkType('client_withdrawal')        
                } else {
                    this.checkType('client_deposit')
                }
            } catch (error) {
                console.log(error)
            }
        },
        checkType(type) {
            this.filterType = type;
        },
        async getWalletHistory(request  = null) {
            try {
                this.selectedRequest = request
                this.loading = true;
                this.spinClass = true;
                let response = await getWalletHistory(this.formDates) 
                setTimeout(()=>{this.spinClass = false;} ,500)
                this.loading = false;
                if(!response?.error){
                    this.walletHistoryList = response?.walletHistoryData;
                }
            } catch (error) {
                this.spinClass = false;
                this.loading = false;
                if (error) {
                    this.$errorToast(error[0]);
                }
            }
        },
        showReportDetailsModal(item) {
            this.selectedReport = item;
            const reportDetails = new Modal("#reportDetailsModal");
            reportDetails.show();
        },        
    }
}
</script>

<style scoped>
.nav-pills .nav-link.active, .nav-pills .show>.nav-link {
    color: #fff !important;
    /* background-color: #0d6efd; */
}
.fa-spin {
  animation: fa-spin 1s linear infinite; 
}

@keyframes fa-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>